
import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import SignInForm from './SignInForm'; // Import the SignInForm component
import ForgotPasswordForm from './ForgotPasswordForm'; // Import the ForgotPasswordForm component
// import actions from '../../ReduxStore/actions';
import logo_login_image from "../../Assets/WeConnectLogo.png";
import login_bgImage from "../../Assets/LoginMainImage.webp";
import { useAuth } from '../AuthContext';
import { useDispatch } from 'react-redux';
import { adminUrl } from '../../constants';
import axios from 'axios';
import actions from '../../ReduxStore/actions';
import { MdMessage } from 'react-icons/md';

const LoginComponent = ({dynamicCampusName,dynamicLogo}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isForgotPassword, setIsForgotPassword] = useState(false);

  const handleGoRegistrationPage = () => {
    navigate("/register");
  };

  // const handleSignInSubmit = async (values) => {
  //   const { email, password } = values;

  //   if (email === 'admin@gmail.com' && password === '1234') {
  //     toast.success('Admin login successful!');
  //     navigate('/home'); // or '/admin-dashboard' if you have a separate admin route
  //   } else if (email === 'user@gmail.com' && password === '1234') {
  //     toast.success('User login successful!');
  //     navigate('/user'); // this should be your user-specific route
  //   } else {
  //     toast.error('Invalid email or password');
  //   }
  // };


  const { login } = useAuth();

  const handleSignInSubmit = async (values) => {
    const { email, password } = values;


    // await axios.get('http://127.0.0.1:8000/sanctum/csrf-cookie', { withCredentials: true });

    // Then post login request

    const data1 = {
      data: {
        personal_email: email,
        password: password,
      },
      method: "post",
      apiName: `loginUser`
    };
    const responseData = await dispatch(actions.LOGINPOST(data1));
    console.log(responseData, "responseDataresponseData")


    if (responseData?.payload?.message === "User logged in successfully.") {


      if (email === 'admin@gmail.com' && password === '1234') {
        // localStorage.setItem('authToken', responseData?.payload?.data?.token);
        // console.log("Full response1:", responseData?.payload?.data?.token);
        // console.log("Full response2:", responseData);

        login({ role: 'admin' }); // 👈 this sets the context
        toast.success('Admin login successful!');

        setTimeout(() => {
          navigate('/admin');
        }, 2500)
      } else {
        // localStorage.setItem('authToken', responseData?.payload?.data?.token);
        sessionStorage.setItem("userId", responseData?.payload?.data?.user_id)
        // sessionStorage.setItem("alumni_user_id",responseData?.payload?.data?.user_id)
        login({ role: 'user' }); // 👈
        toast.success('User login successful!');
        setTimeout(() => {
          navigate('/user');
        }, 2500)
        // navigate('/user');
      }
    } else if (responseData?.payload?.message === "Your account is not approved yet.") {
      toast.warning("Your account is not approved yet.")
    }
    else {
      toast.error(responseData?.payload?.message)
    }
  };
  const handleForgotPasswordSubmit = (values) => {
    console.log(values, "forgot password values");
    toast.success("Password reset link sent!");
    setIsForgotPassword(false)
  };

  const toggleForgotPassword = () => setIsForgotPassword(true);
  const toggleSignIn = () => setIsForgotPassword(false);

  return (

    <Grid container
      sx={{ boxShadow: 3, height: '100vh' }}
    >
      <Grid
        item
        size={{ md: 7 }}
        sx={{
          display: { xs: 'none', md: 'flex' },
          backgroundImage: `linear-gradient(20deg, rgba(0, 0, 0, 1) 11%, rgba(84, 84, 84, 0) 100%), url(${login_bgImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          boxShadow: 5,
          width: '100%',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Box component="img" sr={dynamicLogo} alt="logo"
          // sx={{ width: { xs: "150px", md: "213px" }, height: { xs: "50px", md: "61px" } }}
          width="213px" height="61px"
          sx={{ display: { xs: "block", md: "none" } }}
        />
        <Box display="flex" justifyContent="center" flexWrap="wrap" mt={2}>
          <Box sx={{ color: "#fff" }}>
            <Typography variant="h1" textAlign="center" sx={{ mb: "1px" }}>
              Welcome to {dynamicCampusName}


            </Typography>
            <Typography variant="h2" textAlign="center" sx={{ mb: 2 }}>
              {/* Connecting Students with Job Opportunities */}

              Alumni Hub
            </Typography>
            <Typography
              variant="body1"
              textAlign="center"
              sx={{
                maxWidth: "500px",
                color: "#b0aaaa",
                opacity: 1
              }}
            >
              Alumni posting jobs and internships for Cygnusa community.
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid
        item
        size={{ md: 5, xs: 12 }}


        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
          background: '#FFFFFF',
          width: '100%',

        }}
      >
        <Box sx={{
          width: '100%', maxWidth: 350, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          boxShadow: { xs: 0, sm: 4, md: 0 },
          padding: { xs: 2, sm: 6, md: 0 }
          // border: "1px solid red"
        }}>
          {isForgotPassword ?
            <>
              <Box sx={{ display: { xs: "flex", flexDirection: "column", alignItems: "center", md: "none" } }}>
                <Box
                  component="img"
                  src={dynamicLogo}
                  sx={{ height: { xs: "40px", md: "50px" }, width: { md: "200px", xs: "150px" }, mb: 1 }}
                />
                <Typography variant='h5' fontSize="20px" color='var(--main-color)'>
                  First, let's find your account

                </Typography>
                {/* <Typography
                  variant="body1"
                  textAlign="center"
                  sx={{
                    maxWidth: "500px",
                    color: "#b0aaaa",
                    opacity: 1,
                    mt: 1
                  }}
                >
                  Please enter your email
                </Typography> */}

              </Box>
              <Typography variant="h4" textAlign="center" sx={{ fontSize: { xs: "20px", md: "30px" }, mt: 1, fontWeight: "600", mb: 2 }}>
                Forgot Password
              </Typography>
            </>



            :
            <>
              <Box sx={{ display: { xs: "flex", flexDirection: "column", alignItems: "center", md: "none" } }}>
                <Box
                  component="img"
                  src={dynamicLogo}
                  sx={{ height: { xs: "40px", md: "50px" }, width: { md: "200px", xs: "150px" }, mb: 1 }}
                />
                <Typography variant='h5' fontSize="20px" color='var(--main-color)'>
                  Welcome to Cygnusa
                  Alumni Hub

                </Typography>
                <Typography
                  variant="body1"
                  textAlign="center"
                  sx={{
                    maxWidth: "500px",
                    color: "#b0aaaa",
                    opacity: 1,
                    mt: 1
                  }}
                >
                  Alumni posting jobs and internships for Cygnusa community.
                </Typography>

              </Box>
              <Typography variant="h4" textAlign="center" sx={{ fontSize: "30px", fontWeight: "600", mb: 4, display: { xs: "none", md: "block" } }}>
                Sign In
              </Typography>


            </>
          }


          {isForgotPassword ? (
            <ForgotPasswordForm handleSubmit={handleForgotPasswordSubmit} toggleSignIn={toggleSignIn} />
          ) : (
            <SignInForm handleSubmit={handleSignInSubmit} toggleForgotPassword={toggleForgotPassword} handleGoRegistrationPage={handleGoRegistrationPage} />
          )}
        </Box>
      </Grid>

      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {/* <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" /> */}
    </Grid>
  );
};

export default LoginComponent;
